module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 90);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("@tencent/txv-utils");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("@tencent/e-zepto");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "@babel/runtime/helpers/classCallCheck"
var classCallCheck_ = __webpack_require__(4);
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck_);

// EXTERNAL MODULE: external "@babel/runtime/helpers/createClass"
var createClass_ = __webpack_require__(5);
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass_);

// EXTERNAL MODULE: external "@tencent/e-zepto"
var e_zepto_ = __webpack_require__(16);
var e_zepto_default = /*#__PURE__*/__webpack_require__.n(e_zepto_);

// EXTERNAL MODULE: external "@tencent/txv-utils"
var txv_utils_ = __webpack_require__(1);

// CONCATENATED MODULE: ./src/comps/common/tips/template.js
var tpl = function tpl() {
  return '<div class="mui-tip"></div>';
};
/* harmony default export */ var template = (tpl);
// CONCATENATED MODULE: ./src/comps/common/tips/index.js





var closeTimer = null;
var missAniTimer = null;
var isRendered = false;
var tips_Tips = /*#__PURE__*/function () {
  function Tips(obj) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck_default()(this, Tips);
    this.options = options;
    this.$obj = e_zepto_default()(obj);
    this.init();
  }
  return createClass_default()(Tips, [{
    key: "init",
    value: function init() {
      this.show();
    }
  }, {
    key: "show",
    value: function show() {
      this.$obj.css({
        position: 'fixed',
        top: 0,
        left: 0,
        display: 'block'
      });
      this.posObj();
    }
  }, {
    key: "posObj",
    value: function posObj() {
      var width = this.$obj.width();
      var height = this.$obj.height();
      var wh = e_zepto_default()(window).height();
      var ww = e_zepto_default()(window).width();
      var _this$options = this.options,
        _this$options$x = _this$options.x,
        x = _this$options$x === void 0 ? 0 : _this$options$x,
        _this$options$y = _this$options.y,
        y = _this$options$y === void 0 ? 0 : _this$options$y;
      this.$obj.css({
        position: 'fixed',
        left: Math.floor((ww - width) / 2) + x,
        top: Math.floor((wh - height) / 2) + y
      });
    }
  }]);
}();
/**
 * 只插入一次
 */
var renderTips = Object(txv_utils_["once"])(function () {
  var $tip = e_zepto_default()(template());
  e_zepto_default()('body').append($tip);
  return $tip;
});

/**
 * 插件
 */
e_zepto_default.a.fn.centerShow = function (options) {
  this.each(function () {
    new tips_Tips(this, options);
  });
};
var tips = function tips(options) {
  var _options$text = options.text,
    text = _options$text === void 0 ? '' : _options$text,
    _options$duration = options.duration,
    duration = _options$duration === void 0 ? 1500 : _options$duration,
    _options$addClass = options.addClass,
    addClass = _options$addClass === void 0 ? '' : _options$addClass,
    _options$closed = options.closed,
    closed = _options$closed === void 0 ? function () {} : _options$closed;
  var $tip = renderTips();
  clearTimeout(missAniTimer);
  clearTimeout(closeTimer);
  $tip.html(text).centerShow(options);
  if (!isRendered) {
    $tip.removeClass('mui-tip-show mui-tip-hide').addClass(addClass).centerShow(options);
    isRendered = true;
    $tip.addClass('mui-tip-show');
  }
  closeTimer = setTimeout(function () {
    if (!isRendered) {
      return;
    }
    isRendered = false;
    $tip.addClass('mui-tip-hide');
    missAniTimer = setTimeout(function () {
      $tip.hide();
    }, 500);
    closed();
  }, duration);
};
/* harmony default export */ var common_tips = __webpack_exports__["default"] = (tips);

/***/ })

/******/ })["default"];